export const toolTabs = [
  {
    key: 'on-page-optimization',
    label: 'On Page Optimization'
  },
  {
    key: 'ai-writer',
    label: 'AI Writer'
  },
  {
    key: 'silos',
    label: 'Silos',
    isSpecialUserOnly: true,
  },
  {
    key: 'keyword-research',
    label: 'Keyword Research',
    isSpecialUserOnly: true,
  },
]
